import { render, staticRenderFns } from "./GeneroComponent.vue?vue&type=template&id=f425fafa"
import script from "./GeneroComponent.vue?vue&type=script&lang=js"
export * from "./GeneroComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports